import React from 'react';
import {
  Provider, defaultTheme,
} from '@adobe/react-spectrum';
import PropTypes from 'prop-types';
import GlobalData from '../utils/GlobalData';

export default function MarketoInstancePage(props) {
  const { data, onMarketoInstanceSelect } = props;

  const instanceList = data.map((instance, index) => <button type="button" key={index.toString()} onClick={() => onMarketoInstanceSelect(instance)} >{instance.fulfillableEntityResourceName}</button>);

  return (
    <div className="ScreenContainer">
      <div className="ContentContainer">
        <div className="WelcomeText">{GlobalData.translatedStrings['app.productScreen.title']}</div>
        <div className="SubText">{GlobalData.translatedStrings['app.instanceScreen.subtitle']}</div>
        <div className="ProductsContainer">
          <div className="SingleProductContainer">
            <div className="SingleProduct">
              <Provider theme={defaultTheme}>
                {instanceList}
              </Provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

MarketoInstancePage.propTypes = {
  onMarketoInstanceSelect: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
};
